import { TypeExtends } from "../../dependencies";
TypeExtends();
const prepareDate = (hour) => {
    const date = new Date();
    date.setUTCHours(hour);
    date.setUTCMinutes(0);
    date.setUTCSeconds(0);
    return date;
};
export const getDailyHours = (formatDate, startHours, timeZone) => {
    const dailyHours = [];
    for (startHours; startHours < 24; startHours++) {
        dailyHours.push({
            id: startHours.toString(),
            name: formatDate(prepareDate(startHours).toISOString(), timeZone)
        });
    }
    return dailyHours;
};
//# sourceMappingURL=getDailyHours.js.map